<template>
  <mdb-footer class="page-footer font-small pt-4 w-100" style="backgroundColor: #405d88">
    <mdb-container>
      <mdb-row>
        <mdb-col>
          <img id="footerLogo" src="@/assets/footer.png" alt="FCL Logo">
        </mdb-col>
        
        <mdb-col>
          <h5 class="text-uppercase mb-0 mt-1 font-weight-bold footerText">Business Hours</h5>
          <hr class="accent-2 mb-1 mt-0 d-inline-block mx-auto" style="width: 100%; backgroundColor: #FAFAFA" />
          <ul class="list-unstyled footerText">
            <li>Monday - Friday: <i>8am-5pm</i></li>
            <li>Saturday &amp; Sunday: <i>Closed</i></li>
          </ul>
        </mdb-col>
        
        <mdb-col> 
          <h5 class="text-uppercase mb-0 mt-1 font-weight-bold footerText">Follow Us</h5>
          <hr class="accent-2 mb-1 mt-0 d-inline-block mx-auto" style="width: 100%; backgroundColor: #FAFAFA" />
          <ul class="list-unstyled footerText">
            <li class="mb-2">
              <a href="https://www.facebook.com/FoxdownConstructionLtd/">
                <i class="fab fa-facebook"/>
                <span class="ml-2">Facebook</span>
              </a>
            </li>
            <li class="mb-2">
              <a href="https://www.linkedin.com/company/foxdown-construction-ltd/">
                <i class="fab fa-linkedin-in"/>
                <span class="ml-2">Linkedin</span>
              </a>
            </li>
            <li>              
              <a href="https://www.instagram.com/foxdownconstructionltd">
                <i class="fab fa-instagram"/>
                <span class="ml-2">Instagram</span>
              </a>
            </li>
          </ul>
        </mdb-col>
        
        <mdb-col>
          <h5 class="text-uppercase mb-0 mt-1 font-weight-bold footerText">Contact</h5>
          <hr class="accent-2 mb-1 mt-0 d-inline-block mx-auto" style="width: 100%; backgroundColor: #FAFAFA" />
          <ul class="list-unstyled footerText">
            <!-- <i class="fas fa-home ml-1"/> -->
            <li>Bird in Eye Hill</li>
            <li>Framfield Rd</li>
            <li>Uckfield</li>
            <li>East Sussex</li>
            <li>TN22 5HA</li>
          </ul>

          <span>
            <i class="fas fa-envelope mr-1"/> 
            <a id="footerEmail" href="mailto:admin@foxdownconstruction.co.uk">admin@foxdownconstruction.co.uk</a>
          </span>
          
          <span>
            <i class="fas fa-phone mr-3 mb-0"/>
            <span class="footerText">01825 749389</span>
          </span>
          
        </mdb-col>

		    <mdb-col class="d-none d-lg-block">
			    <img src="@/assets/Images/testlogo.png" height=250 alt="">
        </mdb-col>

      </mdb-row>
    </mdb-container>

    <hr />
    <div class="text-center">
      <ul class="list-unstyled list-inline">
        <li class="list-inline-item"><a class="btn-floating btn-sm btn-fb mx-1" href="https://www.facebook.com/FoxdownConstructionLtd/"><i class="fab fa-facebook"> </i></a></li>
        <li class="list-inline-item"><a class="btn-floating btn-sm btn-li mx-1" href="https://www.linkedin.com/company/foxdown-construction-ltd/"><i class="fab fa-linkedin-in"> </i></a></li>
        <li class="list-inline-item"><a class="btn-floating btn-sm btn-ins mx-1" href="https://www.instagram.com/foxdownconstructionltd"><i class="fab fa-instagram"> </i></a></li>

      </ul>
    </div>
    <div class="footer-copyright text-center py-3">
      <mdb-container fluid>
        &copy; 2021 Copyright: <a href="#"> foxdownconstruction.co.uk </a>
      </mdb-container>
    </div>
  </mdb-footer>
</template>

<script>
  import { mdbFooter, mdbContainer, mdbRow, mdbCol } from 'mdbvue';
  export default {
    name: 'FooterPage',
    components: {
      mdbFooter,
      mdbContainer,
      mdbRow,
      mdbCol
    }
  }
</script>